import React, { useState } from 'react';
import WhatsAppTip from './WhatsAppTip.js';
import { useHints } from '../layout/HintsContext.js';

// DetailWhatsAppTip is the WhatsApp tip on a detail page (lot, list,
// project), shown right under the page header. It's a hint like the hub
// section descriptions: the Show / Hide Hints setting turns it on and off
// everywhere, and ✕ hides it for this visit only (same as the lot protocol
// page's tip). The one-time "✅ … created" tips don't use this.
const DetailWhatsAppTip = ({ title, tips }) => {
  const { hintsVisible } = useHints();
  const [dismissed, setDismissed] = useState(false);

  if (!hintsVisible || dismissed) return null;

  return (
    <div className="detail-whatsapp-tip">
      <WhatsAppTip title={title} tips={tips} onDismiss={() => setDismissed(true)} />
    </div>
  );
};

export default DetailWhatsAppTip;
